"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const InversifySugar_1 = __importDefault(require("./InversifySugar"));
const bindProviderToContainer_1 = require("./binding/bindProviderToContainer");
const createExportedProviderRef_1 = __importDefault(require("./createExportedProviderRef"));
const getModuleMetadata_1 = require("./metadata/getModuleMetadata");
function importDynamicModule({ module, providers: allProviders, exports = [], }) {
    const exportedProviderRefs = [];
    const providers = allProviders.filter((provider) => !provider.isGlobal);
    const globalProviders = allProviders.filter((provider) => !!provider.isGlobal);
    const { container } = (0, getModuleMetadata_1.getModuleMetadata)(module);
    for (const provider of globalProviders) {
        (0, bindProviderToContainer_1.bindProviderToContainer)(provider, InversifySugar_1.default.globalContainer);
    }
    for (const provider of providers) {
        container.bindProvider(provider);
    }
    for (const exportedProvider of exports) {
        exportedProviderRefs.push(...(0, createExportedProviderRef_1.default)(module, exportedProvider));
    }
    return exportedProviderRefs;
}
exports.default = importDynamicModule;
